import React from "react";

export default function SpinnerButton({
  loading, disabled, children, type = "submit", variant = "primary",
  onClick, dataTestId, ariaLabel,
}) {
  const cls = variant === "ghost" ? "scw-btn scw-btn-ghost" : "scw-btn";
  const spinnerCls = variant === "ghost" ? "scw-spinner scw-spinner-dark" : "scw-spinner";
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={loading || disabled}
      className={cls}
      aria-label={ariaLabel}
      data-testid={dataTestId}
    >
      {loading ? <span className={spinnerCls} aria-hidden="true" /> : null}
      <span>{children}</span>
    </button>
  );
}
